import Vue from 'vue';
import VueShortkey from 'vue-shortkey';

/**
 * Easy keyboard shortcuts
 * https://github.com/iFgR/vue-shortkey
 */
Vue.use(VueShortkey, {prevent: ['.v-text-field input', '.v-textarea textarea']});
